import styled from "styled-components";

export const Body = styled.div`
    padding: 24px;
    display: flex;
    justify-content:center;
`